export default __webpack_public_path__ + "static/instagram-17b3d52d642851f1cc12dcb47e9a1f50.png";